import { Injectable } from '@angular/core';
import { ArticleProjectGroupDataService } from '../manager/article-project-group-data.service';
import { ProjectGroupVO } from '../../../model/vo/project-group.vo';
import { lastValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ArticleProjectGroupLoadingService {

  constructor(
    private articleProjectGroupDataService: ArticleProjectGroupDataService
  ) { }

  public loadBaseArticleProjectGroups(level: number = 0): Promise<ProjectGroupVO[]> {
    return lastValueFrom(this.articleProjectGroupDataService.loadBaseArticleProjectGroups(level));
  }

  public loadArticleProjectGroupById(groupId: number, level: number = 0): Promise<ProjectGroupVO> {
    return lastValueFrom(this.articleProjectGroupDataService.loadArticleProjectGroupById(groupId, level));
  }

  public searchArticleProjectGroups(searchString: string, includeOptionValues: boolean, projectsLimit: number = 500) {
    return lastValueFrom(this.articleProjectGroupDataService.searchArticleProjectGroups(searchString, includeOptionValues, projectsLimit));
  }
}
